export default "__VITE_ASSET__5dYYO4rV__"